/**
 * Resolves the server base URL the client should talk to. Order of precedence:
 *
 *   1. `VITE_SERVER_URL` baked at build time (always wins when set).
 *   2. Native (Capacitor) without env → fall back to the production API host.
 *      Capacitor pages live on `capacitor://` so relative URLs would fail.
 *   3. Web (browser) without env → empty string, so requests stay same-origin
 *      and hit nginx's proxy paths (`/auth/...`, `/rooms/...`, etc.).
 *
 * Override the production host at native build time with:
 *   VITE_SERVER_URL=https://api.dontmiss.game pnpm build:native
 */
const PROD_FALLBACK = 'https://api.dontmiss.games';

function isNativeScheme(): boolean {
  if (typeof window === 'undefined') return false;
  const url = window.location.href;
  return url.startsWith('capacitor://') || url.startsWith('ionic://') || url.startsWith('file://');
}

export function getServerUrl(): string {
  const envUrl = import.meta.env.VITE_SERVER_URL;
  if (envUrl) return envUrl.replace(/\/+$/, '');
  if (isNativeScheme()) return PROD_FALLBACK;
  return ''; // same-origin: nginx proxies the API routes
}

export const SERVER_URL = getServerUrl();

/**
 * Headers every API fetch should carry. The `ngrok-skip-browser-warning`
 * bypasses the ngrok free-tier interstitial HTML page — without it, XHR/fetch
 * requests through an ngrok tunnel get the warning page (HTML) instead of our
 * JSON, and every API call fails to parse. Harmless on non-ngrok origins.
 */
export const COMMON_HEADERS: Record<string, string> = {
  'ngrok-skip-browser-warning': 'true',
};
